export default __webpack_public_path__ + "8075bbb2c1720f4585ed6cc4c6b88934.jpg";